angular
  .module('contrast.ip')
  .factory('IPBlacklistFactory', function ($http, UserService) {
    var service = {
      getIPBlacklist: getIPBlacklist,
      getIPWhitelist: getIPWhitelist,
      getAddress: getAddress,
      deleteAddress: deleteAddress,
      toggleEnabled: toggleEnabled,
      addAddress: addAddress,
      editAddress: editAddress,
      checkName: checkName,
      checkNameUpdate: checkNameUpdate
    }

    return service

    function getIPBlacklist() {
      return $http.get(UserService.buildAPIUrl('/ip/blacklist'))
    }

    function getIPWhitelist() {
      return $http.get(UserService.buildAPIUrl('/ip/whitelist'))
    }

    function getAddress(addressUuid) {
      return $http.get(UserService.buildAPIUrl('/ip/' + addressUuid))
    }

    function deleteAddress(addressUuid) {
      return $http['delete'](UserService.buildAPIUrl('/ip/' + addressUuid))
    }

    function toggleEnabled(addressUuid, environment) {
      return $http.post(
        UserService.buildAPIUrl('/ip/' + addressUuid + '/enable/' + environment)
      )
    }

    function addAddress(form) {
      return $http.put(UserService.buildAPIUrl('/ip'), form)
    }

    function editAddress(addressUuid, form) {
      return $http.post(UserService.buildAPIUrl('/ip/' + addressUuid), form)
    }

    function checkName(name, trusted) {
      return $http.post(UserService.buildAPIUrl('/ip/unique'), {
        name: name,
        trusted: trusted
      })
    }

    function checkNameUpdate(uuid, name, trusted) {
      return $http.post(UserService.buildAPIUrl('/ip/' + uuid + '/unique'), {
        name: name,
        trusted: trusted
      })
    }
  })
